/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Hero_TagInputs */

const en_platform_hero_tag = /** @type {(inputs: Platform_Hero_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule, plans, diet and passes in one app`)
};

const pl_platform_hero_tag = /** @type {(inputs: Platform_Hero_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik, plany, dieta i karnety w jednej aplikacji`)
};

/**
* | output |
* | --- |
* | "Schedule, plans, diet and passes in one app" |
*
* @param {Platform_Hero_TagInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_hero_tag = /** @type {((inputs?: Platform_Hero_TagInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Hero_TagInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_hero_tag(inputs)
	return en_platform_hero_tag(inputs)
});